module.exports = __webpack_public_path__ + "img/profile.9d87b46b.svg";